import styled from 'styled-components'
import { Box, Typography } from 'src/components'
import { motion } from 'framer-motion'

export const OverContainerSection = styled(Box)`
    display: flex;
    align-items: center;
    position: relative;
    flex-direction: column;
`

export const Content = styled(Box)`
    width: 100%;
    height: 300px;
    display: flex;
    justify-content: center;
    position: relative;
    align-items: center;
    flex-direction: column;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const ContentInformation = styled(Box)`
    height: 50%;
    z-index: 20;
    display: flex;
    justify-content: space-around;
    position: relative;
    align-items: center;

    flex-direction: column;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        height: 45%;
        align-items: center;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        height: 45%;
        align-items: start;
    }
`
export const Back = styled(Box)`
    width: 100%;
    justify-content: start;
    align-items: start;
    display: flex;
    flex-direction: column;
    z-index: 20;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 95%;
        flex-direction: column;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1200px;
        flex-direction: column;
        justify-content: start;
        align-items: start;
    }
`
export const ContentImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: none;
    position: absolute;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: none;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        display: flex;
    }
`
export const ContentImageT = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    display: none;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: flex;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        display: none;
    }
`
export const ContentImageM = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    display: flex;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: none;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        display: none;
    }
`
export const OverSpan = styled.span`
    position: absolute;
    background-size: cover;
    background-position: center center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.8;
    background-image: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
    );
`
export const TypographyHeader = styled(motion(Typography))`
    font-family: inherit;
    font-style: normal;
    line-height: 46px;
    -webkit-background-clip: text;
    text-align: start;
    text-transform: uppercase;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 54px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 42px;
    }
`
export const ContentData = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 26px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const ContentName = styled(Box)`
    display: flex;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const TypographyDate = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 90.9%;
`
export const ImageIcon = styled.img`
    width: 20px;
    object-fit: contain;
    margin-right: 4px;
`
export const TitleTypography = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    text-align: center;
    margin-top: 10px;
    line-height: 110.9%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        text-align: center;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        text-align: start;
    }
`
